import { render } from "./TutorialButton.vue?vue&type=template&id=5285c09e&scoped=true"
import script from "./TutorialButton.vue?vue&type=script&lang=js"
export * from "./TutorialButton.vue?vue&type=script&lang=js"

import "./TutorialButton.vue?vue&type=style&index=0&id=5285c09e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5285c09e"]])

export default __exports__